import * as THREE from 'three';

export const raycaster_main: THREE.Raycaster = new THREE.Raycaster();
raycaster_main.firstHitOnly = true; // makes it faster (we only use first hit anyway)
raycaster_main.layers.set(0); // set the layer to 0 (normal layer)

export const raycaster_allLayers: THREE.Raycaster = new THREE.Raycaster();
raycaster_allLayers.firstHitOnly = true; // makes it faster (we only use first hit anyway)
raycaster_allLayers["HTMLInVR_allowHit"] = true; // allow raycast hits on HTMLInVR